var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "-282 389.3 31.7 17.8",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-253.3 395.8-3.2-4.8h-3.2l-1.6-1.7H-282v14.6h1.7c-.1.3-.2.5-.2.8 0 1.4 1.1 2.4 2.4 2.4 1.4 0 2.4-1.1 2.4-2.4 0-.3-.1-.5-.2-.8h19.4c-.1.3-.2.5-.2.8 0 1.4 1.1 2.4 2.4 2.4 1.4 0 2.4-1.1 2.4-2.4 0-.3-.1-.5-.2-.8h.9v-.2c.9-.4.9-1.5.9-1.5V399c.3-1.7-3-3.2-3-3.2m-6.4 0v-3.3h2.4l1.8 3.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-281.1 392h18.8v6.7h-18.8z"
  })));
};
export default SvgTruck;